// src/layouts/components/UserMenu.jsx

import { useAuth } from "../../auth/authContext";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import AVIcon from "../../components/icons/AllVoicedIcons";
import axios from "axios";
import LogoutComponent from "../../auth/components/LogoutComponent";

const PROFILE_ROUTE = "/app/profile";

const UserMenu = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const apiUrl =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5001/api";

  const isInApp =
    location.pathname.startsWith("/app");

  const isVerified =
    user?.isVerified === true;

  const displayLabel =
    user?.displayName ||
    user?.username ||
    user?.email?.split("@")[0] ||
    t("user", { defaultValue: "User" });

  const handleGoToProfile = () => {
    navigate(PROFILE_ROUTE);
  };

  const handleResendVerification = async () => {
    if (!user?.email) {
      return;
    }

    try {
      await axios.post(
        `${apiUrl}/users/resend-verification`,
        { email: user.email }
      );

      alert(
        t("verification_email_resent", {
          defaultValue: "Verification email resent."
        })
      );
    } catch (error) {
      console.error("Error resending verification email:", error);

      alert(
        t("error_resending_verification", {
          defaultValue: "Error resending verification email."
        })
      );
    }
  };

  return (
    <div className="user-menu hover-user-menu">
      <button
        className="menu-icon user-menu-trigger"
        title={t("profile_and_settings", {
          defaultValue: "Profile & settings"
        })}
        type="button"
      >
        <AVIcon
          icon="user"
          size={30}
          color="#209385"
          showAlert={!isVerified}
        />
      </button>

      <ul className="header-dropdown-menu align-right">
        <li className="user-menu-summary">
          <strong>{displayLabel}</strong>

          {user?.email && (
            <span>{user.email}</span>
          )}
        </li>

        <li>
          <button
            type="button"
            onClick={handleGoToProfile}
          >
            {t("profile", {
              defaultValue: "Profile"
            })}
          </button>
        </li>

        {!isVerified && (
          <li>
            <button
              type="button"
              onClick={handleResendVerification}
              className="user-menu-warning-action"
            >
              {t("verify_email", {
                defaultValue: "Verify email"
              })}

              <span className="notification-dot" />
            </button>
          </li>
        )}

        {isInApp ? (
          <li>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("visit_website", {
                defaultValue: "Visit website"
              })}
            </a>
          </li>
        ) : (
          <li>
            <a href="/app">
              {t("go_to_app", {
                defaultValue: "Go to app"
              })}
            </a>
          </li>
        )}

        <li className="user-menu-separator" />

        <li>
          <LogoutComponent />
        </li>
      </ul>
    </div>
  );
};

export default UserMenu;